'use client';
import { useTranslation } from '@/i18n/client';
import { useRouter } from 'next/navigation';
import ProductCard from '@/components/productCard';
import ArrowRight from './img/ArrowRightBlack.svg';
import style from './style.module.scss';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';

// ---------------- 监控 ---------------- //
import {
  NEW_COMER_EVENT_NAMES,
  newComerBusinessLogger,
  NEW_COMER_TRACK_TYPE,
} from '@/utils/logger/instance/newComerBusinessLogger';
export default function Module({ moduleData, localInfo }: { moduleData: any; localInfo: any }) {
  const pageConfig: any = {};
  const { dataBatch } = moduleData;
  const { t } = useTranslation();
  const router = useRouter();
  const handlerGotoLand = () => {
    router.push('/promo/welcome-discounts');
  };

  const initConfig = (moduleData: any) => {
    pageConfig.total = moduleData.externalData?.data?.products?.total;
    pageConfig.products = moduleData.externalData?.data?.products.list.slice(0, 3);
    pageConfig.jumpParams = moduleData.dataBatch?.config[0]?.moreLinks;
    pageConfig.containerStyle = {
      marginTop: (moduleData.dataStyle.style.mt || 0) + 'px',
      marginBottom: (moduleData.dataStyle.style.mb || 0) + 'px',
    };

    // --------------商卡信息--------------
    pageConfig.products?.forEach((p: any, index: number) => {
      p.type = '1';
      p.skuId = p?.skuId;
      p.skuName = p?.skuName;
      p.currency = localInfo?.currencyCode;
      p.languageCode = localInfo?.languageCode;
      p.skuImg = p?.imageUrl;
      p.originalPrice = p?.originalPriceV2;
      p.originalPriceTips = p?.originalPriceDesc;
      p.onClickProduct = (props: any) => handlerGotoLand();
      p.spmTrackParams = genEventTrackingInfo(p, index);
      p.priority = index < 4;

      // style
      p.width = '100%';
      p.height = 'auto';
      p.skuImgStyle = {
        alignItems: 'center',
        width: '100%',
        aspectRatio: '1',
      };
      p.priceStyle = {
        marginTop: '8px',
        fontSize: '12px',
        //@ts-ignore
        textAlign: 'center' as TextAlign,
        height: 'auto',
      };
      p.realPriceJDIPriceParams = {
        containerStyle: {
          fontWeight: '700',
          lineHeight: '18px',
          fontSize: '18px',
          color: '#cc1c0c',
        },
        integerStyle: { fontSize: '18px', color: '#cc0c1c', lineHeight: '18px', weight: '700' },
        symbolStyle: { fontSize: '12px' },
      };
      p.originalPriceJDIPriceParams = {
        containerStyle: {
          fontWeight: '500',
          fontSize: '12px',
          lineHeight: '16px',
        },
      };
    });
  };

  const genEventTrackingInfo = (product: any, index: number) => {
    const spmTrackParams = {} as { [key: string]: any };
    const json_param = { skuid: product.skuId, index: index };
    const expConfig = {
      useClick: false,
      stay_duration: 0,
      repeated: false,
      area_rate: 0.01,
    };
    spmTrackParams['productClick'] = {
      spm: `a0145.b002218.c00002484.${index + 1}`,
      page_id: 'Home_Main',
      event_id: 'Home_Welcome',
      json_param: json_param,
    };
    spmTrackParams['productExpConfig'] = {
      spm: `a0145.b002218.c00002484.${index + 1}`,
      page_id: 'Home_Main',
      event_id: 'Home_Welcome_Expo',
      config: expConfig,
      json_param: json_param,
    };
    return spmTrackParams;
  };

  initConfig(moduleData);
  if (pageConfig?.products?.length === 0) {
    newComerBusinessLogger({
      eventName: NEW_COMER_EVENT_NAMES.NEW_COMER_PRODUCT_NUM_ERROR,
      category: {
        type: NEW_COMER_TRACK_TYPE.NEW_COMER_JS_ERROR,
      },
      message: {
        msg: '没有商品，不展示楼层',
      },
    });
  }
  return (
    <>
      {!!pageConfig?.products?.length && (
        <div
          className={style.discount_list_wrap}
          style={pageConfig.containerStyle}
          data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
          data-exp={JSON.stringify({
            spm: 'a0145.b002218.c00002484.more',
            page_id: 'Home_Main',
            event_id: 'Home_Welcome_More_Expo',
          })}
        >
          <div className={style.title}>{dataBatch?.config[0].title || t('welcome.title')}</div>
          <div
            onClick={(e) => {
              spmTrackingUtils.spmClick({
                spm: 'a0145.b002218.c00002484.more',
                page_id: 'Home_Main',
                event_id: 'Home_Welcome_More',
                target: e.target as HTMLElement,
              });
              handlerGotoLand();
            }}
          >
            <div className={style.land_btn}>
              <p className={style.land_text}>
                {dataBatch?.config[0].jumpButtonName || t('welcome.newUser')}
              </p>
              <ArrowRight color='#1A1A1A' className={style.arrow_right} />
            </div>
          </div>
          <div className={style.card_wrap}>
            <div className={style.card_slider}>
              {pageConfig?.products.map((product: any, index: any) => (
                <div className={style.card} key={product.skuId} onClick={handlerGotoLand}>
                  <ProductCard productData={product} key={product?.skuId} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
